import { render, staticRenderFns } from "./MobileOtherProfile.vue?vue&type=template&id=469e2bfc&scoped=true"
import script from "./MobileOtherProfile.vue?vue&type=script&lang=js"
export * from "./MobileOtherProfile.vue?vue&type=script&lang=js"
import style0 from "./MobileOtherProfile.vue?vue&type=style&index=0&id=469e2bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469e2bfc",
  null
  
)

export default component.exports